import { call, select, take } from 'redux-saga/effects';
import { SparteAntrag } from '@ps20/bff-models';
import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import type { IAppState } from '../localStore';

const globalActions = new GlobalActions();

export function* getVorschlagsdaten(): Generator {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();
  const vorschlagsdaten: Array<SparteAntrag> = [];

  const angeboteInWarenkorb: AngebotsId[] = state.produkte.map(({ appId, angebotsId }) => ({
    appId: appId,
    angebotsId,
  }));

  yield call(
    globalPut.put.bind(globalPut),
    globalActions.vorschlagsdatenRequested(angeboteInWarenkorb),
  );

  for (const _produkt of state.produkte) {
    const vorschlagsdatenAction: GlobalAction<SparteAntrag> = yield take(
      GlobalActions.VORSCHLAGDATEN_GENERATED,
    );
    const sparteAntrag = {
      ...vorschlagsdatenAction.payload,
    };
    vorschlagsdaten.push(sparteAntrag);
  }

  return vorschlagsdaten;
}
